import { Injectable } from '@angular/core';
import { IgenomicsState } from '../../../core/interfaces/genomics-state.interface';
import { Store } from '@ngrx/store';
import { REPORT_PREVIEW_ACTIONS } from '../constants/report-preview.constants';
import { reviewItem } from '../constants/review-item.constants';
import * as immutable from 'immutable';

@Injectable()
export class ReportPreviewActionsService {

  constructor(store: Store<IgenomicsState>) {
    this.store$ = store.select('tests', 'reportPreview');
  }
  private static userID: string;
  private store$: any;

  public setState(state, userID) {
    ReportPreviewActionsService.userID = userID;
    this.store$.dispatch({
      type: REPORT_PREVIEW_ACTIONS.SET_STATE,
      payload: {
        state,
        userID: ReportPreviewActionsService.userID
      }
    });
  }
}
